import React from 'react';

const DifficultySelector = ({ difficulty, setDifficulty }) => {
  return (
    <select 
      value={difficulty} 
      onChange={(e) => setDifficulty(e.target.value)}
      className="difficulty-selector"
    >
      <option value="easy">Easy</option>
      <option value="medium">Medium</option>
      <option value="hard">Hard</option>
    </select>
  );
};

export default DifficultySelector;